import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Model from '@tripian/model';

import IFocusState from '../redux/model/IFocusState';
import ICombinedState from '../redux/model/ICombinedState';
import { changeFocusedStep, changeFocusedAlternative, changeFocusedPoi, clearFocus } from '../redux/action/focus';
import gmapGlobal from '../redux/gmapGlobal';

const useFocus = () => {
  const focus: IFocusState = useSelector((state: ICombinedState) => state.focus);

  const dispatch = useDispatch();

  const focusStep = useCallback(
    (step: Model.Step) => {
      dispatch(changeFocusedStep(step));

      gmapGlobal.setGmapCenter(step.poi.marker_coordinate);
      gmapGlobal.setGmapZoomFocus();
    },
    [dispatch],
  );

  const focusAlternative = useCallback(
    (stepId: number, poi: Model.Poi) => {
      dispatch(changeFocusedAlternative(stepId, poi));

      gmapGlobal.setGmapCenter(poi.marker_coordinate);
      gmapGlobal.setGmapZoomFocus();
    },
    [dispatch],
  );

  const focusPoi = useCallback(
    (poi: Model.Poi) => {
      dispatch(changeFocusedPoi(poi));

      gmapGlobal.setGmapCenter(poi.marker_coordinate);
      gmapGlobal.setGmapZoomFocus();
    },
    [dispatch],
  );

  const focusLost = useCallback(() => {
    dispatch(clearFocus());
  }, [dispatch]);

  return { focus, focusLost, focusStep, focusAlternative, focusPoi };
};

export default useFocus;
